
// Size Guide V2 — Interactive Size Finder
(function() {
  var sizeData = {
    'nb':     { label: 'Newborn (NB)', detail: 'Up to 8 lbs, up to 21.5". Typically fits 0-4 weeks.' },
    '0-3m':   { label: '0-3 Months', detail: '8-12 lbs, 21-24". Typically fits 4-8 weeks.' },
    '3-6m':   { label: '3-6 Months', detail: '12-17 lbs, 24-26.5". Typically fits 6-8 weeks.' },
    '6-9m':   { label: '6-9 Months', detail: '17-21 lbs, 26.5-28.5". Typically fits 8-10 weeks.' },
    '9-12m':  { label: '9-12 Months', detail: '21-24 lbs, 28.5-30.5". Typically fits 8-10 weeks.' },
    '12-18m': { label: '12-18 Months', detail: '24-27 lbs, 30.5-32.5". Typically fits 3-4 months.' },
    '18-24m': { label: '18-24 Months', detail: '27-30 lbs, 32.5-35". Typically fits 3-4 months.' }
  };

  var buttons = document.querySelectorAll('.sg-finder__btn');
  var resultBox = document.getElementById('sg-finder-result');
  var resultSize = document.getElementById('sg-result-size');
  var resultDetail = document.getElementById('sg-result-detail');
  var rows = document.querySelectorAll('#sg-table tbody tr');

  if (!buttons.length) return;

  buttons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var size = this.getAttribute('data-size');
      var data = sizeData[size];
      if (!data) return;

      buttons.forEach(function(b) { b.classList.remove('sg-finder__btn--active'); });
      this.classList.add('sg-finder__btn--active');

      resultSize.textContent = 'We suggest: ' + data.label;
      resultDetail.textContent = data.detail;
      resultBox.style.display = 'block';

      rows.forEach(function(row) {
        if (row.getAttribute('data-size') === size) {
          row.classList.add('sg-table__row--highlight');
        } else {
          row.classList.remove('sg-table__row--highlight');
        }
      });

      var chart = document.getElementById('sg-chart');
      if (chart) {
        setTimeout(function() {
          chart.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 200);
      }
    });
  });
})();
